import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import MainWindow from './Wrappers/MainWindow';
import { Row, Col } from './Grid';
import { AnalyticsService } from '../services/AnalyticsService';
import createOffer from '../svg/create-offer.svg';
import profile from '../svg/profile.svg';
import offers from '../svg/offers.svg';
import results from '../svg/results.svg';
import iphone from '../svg/iphone.svg';

const Main = styled.div`
  margin: 30px 30px 30px -10px;
  font-family: BrandonGrotesque-Regular;
  font-size: 80px;
  letter-spacing: 2px;
  color: var(--color-beige);
  width: calc(100%);
  background-color: var(--color-gunmetal);
  border-radius: 5px;
  margin-right: 15px;
  height: 470px;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 40px;
`;

const Link = styled.div`
  width: 17vw;
  height: 17vw;
  background-color: var(--color-beige-two);
  text-align: center;
  color: var(--color-greyish-brown);
  letter-spacing: 1.5px;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  font-family: BrandonGrotesque-Regular;
`;

const LinkTitle = styled.div`
  font-family: BrandonGrotesque-Bold;
  font-size: 15px;
`;

const LinkText = styled.div`
  width: 182px;
  display: inline-block;
  font-size: 12px;
`;

const Inner = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

const Explanation = styled.div`
  padding: 50px 30px;
  font-size: 20px;
  line-height: normal;
  letter-spacing: normal;
  color: var(--color-white-two);
`;

const Subtext = styled.div`
  font-size: 40px;
  padding: 0px 35px;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
`;

interface Props {
  business: any;
  goTo: Function;
}

function Dashboard(props: Props) {
  document.title = 'Home • Neoncoat Brands Tool';

  return (
    <MainWindow page="dashboard">
      <Main>
        <Row>
          <Col size="5">
            <div style={{ padding: '10px 30px 0px 30px' }}>Welcome,</div>
            <Subtext>{props.business.name}</Subtext>
            <Explanation>
              Neon Coat is fully customizable in order to provide you with the best experience. Use
              the quick-links below to get started!
            </Explanation>
          </Col>
          <Col size="2" />
          <Col size="4">
            <div style={{ marginTop: '35px' }}>
              <img src={iphone} height="380px" alt="" />
            </div>
          </Col>
          <Col size="1" />
        </Row>
      </Main>
      <LinkContainer>
        <Link onClick={() => props.goTo('Active Offers', '/offers/active')}>
          <Inner>
            <Icon src={offers} alt="View offers" />
            <LinkTitle>VIEW OFFERS</LinkTitle>
            <LinkText>Check on your active, upcoming or past offers</LinkText>
          </Inner>
        </Link>
        <Link onClick={() => props.goTo('Create Offer', '/offers/create')}>
          <Inner>
            <Icon src={createOffer} alt="Create new offer" />
            <LinkTitle>CREATE OFFER</LinkTitle>
            <LinkText>Add a one time event, or recurring offer</LinkText>
          </Inner>
        </Link>
        <Link onClick={() => props.goTo('IG Results', '/results')}>
          <Inner>
            <Icon src={results} alt="View results" />
            <LinkTitle>VIEW RESULTS</LinkTitle>
            <LinkText>See what the models have posted about your Brand</LinkText>
          </Inner>
        </Link>
        <Link onClick={() => props.goTo('Profile', '/profile')}>
          <Inner>
            <Icon src={profile} alt="Profile details" />
            <LinkTitle>PROFILE DETAILS</LinkTitle>
            <LinkText>Update your business hours and description</LinkText>
          </Inner>
        </Link>
      </LinkContainer>
    </MainWindow>
  );
}

function mapStateToProps(state) {
  return {
    business: state.business,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goTo: (name, url: string) => {
      AnalyticsService.track(name + ' tap', {});
      dispatch(push(url));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
